import { withAsyncLoading } from '../../../Components/Templates/Loading/AsyncPageLoading/withAsyncPageLoading';

const LoadableMaterielDetailsPage = withAsyncLoading(async () =>
    import('./MaterielDetailsPage').then((res) => res.MaterielDetailsPage)
);

export { LoadableMaterielDetailsPage };
